// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"9fa2efd6","488":"be46ab81"}[chunkId] + ".chunk.js";
};